import type { ReactNode } from "react";

import { cn } from "../lib/cn";

/**
 * The control-scoped loading mark. Size is a class the caller passes. Hidden
 * from assistive technology.
 */
export type typeSpinnerProps = {
  className: string;
} & { "data-testid"?: string | undefined };

export const Spinner = ({
  className,
  "data-testid": testId,
}: typeSpinnerProps): ReactNode => (
  <svg
    className={cn("animate-spin motion-reduce:animate-none", className)}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    data-testid={testId}
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2.5"
      opacity="0.25"
    />
    <path
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
